<template>
    <div class="home-page">
    <!-- altro codice -->
    </div>
</template>

<script>
    export default {
        name: 'HomeComponent',
    }
</script>